<template>
    <a href="javascript:;" @click="handleCouponClick">
        <div class="coupon">
            <div class="coupon-left"
                 :style="couponStyle">
                <div class="half-circle"></div>
                <div class="coupon-content">
                    <div class="photo">
                        <img :src="coupon.shopLogo"
                             alt="">
                    </div>
                    <div class="msg">
                        <h4>{{coupon.name}}</h4>
                        <p>{{coupon.subName}}</p>
                    </div>
                </div>
            </div>
            <div class="coupon-right"
                 :class="{'coupon-right-orange': status, 'coupon-right-gray': !status}">
                <div class="coupon-status">
                    <p class="text">{{coupon.price | formatPrice}}</p>
                    <p>
                        <span class="status">{{coupon.obtainStatus | formatStatusText}}</span>
                    </p>
                </div>
            </div>
        </div>
    </a>
</template>
<script>
import { COUPONSTATUS } from '../constants'
export default {
    name: 'coupon',
    data() {
        return {}
    },
    filters: {
        formatPrice(value) {
            if (value === 0) return '免费'
            return `¥${(value / 100.0).toFixed(2)}`
        },
        formatStatusText(value) {
            return COUPONSTATUS[value]
        }
    },
    computed: {
        couponStyle() {
            let style = {}
            style.background = `url(${this.coupon.couponPicUrl}) no-repeat`
            style.backgroundSize = 'cover'
            return style
        },
        status() {
            let s = this.coupon.obtainStatus
            if (s === 1 || s === 4) return true
            return false
        }
    },
    props: {
        coupon: [Object]
    },
    methods: {
        handleCouponClick() {
            this.$emit('couponClick', this.coupon)
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/css/px2rem.scss';
@import '../../../assets/css/colors.scss';
$coupon-height: px2rem(110);
.coupon {
    height: $coupon-height;
    display: flex;
    margin: px2rem(10) 0;
    border-radius: px2rem(4);
    overflow: hidden;
    &-left {
        width: px2rem(250);
        background-color: $gray;
        position: relative;
        overflow: hidden;
        .half-circle {
            position: absolute;
            width: px2rem(24);
            height: px2rem(24);
            border-radius: px2rem(100);
            left: 0;
            top: 50%;
            background-color: white;
            transform: translate3d(-50%, -50%, 0);
        }
        .coupon-content {
            position: absolute;
            left: 50%;
            top: 50%;
            font-size: px2rem(20);
            color: white;
            transform: translate3d(-50%, -50%, 0);
            width: 100%;
            padding: 0 px2rem(24);
            display: flex;
            .photo {
                $photo-len: px2rem(58);
                width: $photo-len;
                height: $photo-len;
                border-radius: px2rem(100);
                background-color: white;
                overflow: hidden;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .msg {
                width: 0;
                flex: 1;
                padding: 0 0 0 px2rem(12);
                h4 {
                    line-height: px2rem(22);
                    font-size: px2rem(16);
                    margin-bottom: px2rem(12);
                    color: white;
                    white-space:nowrap; 
                    text-overflow:ellipsis;
                    overflow: hidden;
                }
                p {
                    line-height: px2rem(20);
                    font-size: px2rem(14);
                    color: white;
                    white-space:nowrap; 
                    text-overflow:ellipsis;
                    overflow: hidden;
                }
            }
        }
    }
    &-right {
        width: 0;
        flex: 1;
        position: relative;
        .coupon-status {
            position: absolute;
            line-height: px2rem(25);
            left: 50%;
            top: 50%;
            font-size: px2rem(20);
            color: white;
            width: auto;
            transform: translate3d(-50%, -50%, 0);
            p {
                text-align: center;
                .status {
                    display: inline-block;
                    line-height: px2rem(28);
                    text-align: center;
                    border: px2rem(1) solid white;
                    border-radius: px2rem(35);
                    font-size: px2rem(10);
                    min-width: px2rem(56);
                    margin: px2rem(4) 0;
                }
            }
            .text {
                line-height: px2rem(25);
                font-size: px2rem(24);
                text-align: center;
            }
        }
    }
}
.coupon-right-orange {
    background: url('../../../assets/img/food_quan_jianbian@3x.png') no-repeat;
    background-size: 100% 100%;
}
.coupon-right-gray {
    background: url('../../../assets/img/food_quan_gray@3x.png') no-repeat;
    background-size: 100% 100%;
}
</style>


